import jwt_decode from 'jwt-decode'
import { getRoutes } from '../../getRoutes'
import { ALLOWED_DASHBOARD_VIEWERS } from '../../utils/consts'

export const departmentIDs = {
  IT: '60dad7f65f871377f59e780d', // Pikotel
  Compliance: '6459ff3827e0949da9ebaa1a', // Compliance & Data Security
  Quality: '5d9b27f7d489d437f2950595', // Quality
  Sales: [
    '5d9b2813d489d437f2950597', // Sunrise - Telesales Inbound
    '5d9b2829d489d437f2950598', // Sunrise - Telesales Outbound
    '5d9b2758d489d437f295058e', // B2B Leadgen
    '60dac0275f871377f59e759d', // Management
    '669e46e2d95d316486b4fda2', // B2B Quality
    '669e46ced95d316486b4fc3b', // B2B Medium Sales
    '669e46b4d95d316486b4fa59', // B2B Small Sales
    '6464978027e0949da90482cc', // MIX Team

    '67fd0c42c78b0a001b8928e5', // B2B Small Outbound
    '67fd0c5aaf4763001be2adc6', // B2B New Outbound
    '67fd0c6ee513e5001b1b5ea9', // B2B Small Inbound
    '67fd0c8ac78b0a001b8929d3', // B2B Medium Outbound
    '67fd0c9fe513e5001b1b5efd', // EP Sales
    '67fd0cb0af4763001be2ae89', // B2B Small Retention
    '67fd0cc5e513e5001b1b5f84', // B2B Medium Retention
    '5d9b2806d489d437f2950596', // Sunrise - Retention
    '6464bba327e0949da9056a64', // Backoffice Retention
    '6400a3fd73303f9006a665cd', // Sunrise - Retention BMM
    '6299cf7664de1d5aaf015ebc', // Sales Outbound Retention
    '60746341d80dab068a744659', // UPC RETENTION
    '5e843fc4a6152815d8f149dc', // Sunrise Retention - Chat
    '5ddf901b245dd830d3abb463', // FLB Retention
    '600ec8702c7fcc068372e18b', // Retention Vushtrri
    '643802a6597f187f3bc1f94b', // Test Retention
    '6287655864de1d5aafc94db7', // Backoffice Retention CC
    '5ddf902e245dd830d3abb464', // YOL Retention Chat
    '605061e2d80dab068a73d30d', // YOL RETENTION VUSHTRRI
    //Maybe not used
    '60746327d80dab068a744657', // UPC SALES
    '5f57886559afbc06770e9a85', // Sunrise - Sales Outbound 2
    '602ce76ad80dab068a734588', // Sunrise - Sales Inbound 2
    '68a42cae1c841200137b2a42', // Sunrise Telesales Home Security
    '60a7a446a51abf1e2b1e6264',  // ---DOESNT EXISTS
  '69c406c010fa72001b94d6be' // 
  ],
  MobileZone: ['65f1b308e4e23cf23d2c2cef', '6440e7c18422a203756af274', '64648a4a27e0949da904059e'],
  TimeTracking: ['60dad19b5f871377f59e7756', '67d2aca4316e65001ba15c02', '6825d6c7110faf0015741f4f', '67a1d8ab49a98e001b4d0a0e']
}

const checkDepartment = (department, ids) => ids.some((id) => department.includes(id))
const allowedIds = ALLOWED_DASHBOARD_VIEWERS?.split(',') || []
const checkUserIds = (user_id) => allowedIds.includes(user_id)

// SP-467: Erza Nura
const ALLOWED_VISITOR_BADGE_USER_IDS = ['6a2d141a22f28bf2f5d34bba']

export const getRoutesData = () => {
  const token = localStorage.getItem('token')
  const { user_level, department, user_id, permissions_keys } = jwt_decode(token)
  const has_workforce_manager_access = permissions_keys?.includes('has_workforce_manager_access')

  return getRoutes({
    user_level,
    isITUser: checkDepartment(department, [departmentIDs.IT]),
    isComplianceUser: checkDepartment(department, [departmentIDs.Compliance]),
    isQualityUser: checkDepartment(department, [departmentIDs.Quality]),
    isSalesUser: checkDepartment(department, departmentIDs.Sales),
    isMobileZoneDepartment: checkDepartment(department, departmentIDs.MobileZone),
    dashboardViewers: checkUserIds(user_id),
    isAllowedVisitorBadgeUser: ALLOWED_VISITOR_BADGE_USER_IDS.includes(user_id),
    permissions_keys,
    has_workforce_manager_access
  })
}
